import React from 'react';
import FilterRangeSlider from './fields/FilterRangeSlider';
import FilterCheckbox from './fields/FilterCheckbox';
import SubcategoriesCheckbox from './fields/SubcategoriesCheckbox';
import FilterRadio from './fields/FilterRadio';
import SubcategoriesRadio from './fields/SubcategoriesRadio';

export const filters = {
    rentOrBuy: (values, prevValue, handleChange, type) => {
        if (type === 'checkbox') {
            return (
                <FilterCheckbox
                    name="rentOrBuy"
                    label="Аренда/Продажа"
                    prevValue={prevValue}
                    values={values}
                    onHandleChange={handleChange}
                />
            );
        } else {
            return <FilterRadio name="rentOrBuy" label="Аренда/Продажа" value={prevValue} values={values} onHandleChange={handleChange} />;
        }
    },
    price: (min, max, handleChange) => (
        <FilterRangeSlider name="price" label="Цена, руб." min={min} max={max} onHandleChange={handleChange} />
    ),
    liftingCapacity: (min, max, handleChange) => (
        <FilterRangeSlider
            name="liftingCapacity"
            label="Грузоподъемность, кг"
            min={min}
            max={max}
            step={0.1}
            onHandleChange={handleChange}
        />
    ),
    maxBoomReach: (min, max, handleChange) => (
        <FilterRangeSlider name="maxBoomReach" label="Макс. вылет стрелы, м" min={min} max={max} step={0.1} onHandleChange={handleChange} />
    ),
    weight: (min, max, handleChange) => (
        <FilterRangeSlider name="weight" label="Вес, кг" min={min} max={max} step={0.1} onHandleChange={handleChange} />
    ),
    drive: (values, prevValue, handleChange) => (
        <FilterCheckbox name="drive" label="Привод" values={values} prevValue={prevValue} onHandleChange={handleChange} />
    ),
    use: (values, prevValue, handleChange) => (
        <FilterCheckbox name="use" label="Применение" values={values} prevValue={prevValue} onHandleChange={handleChange} />
    ),
    towerType: (values, prevValue, handleChange) => (
        <FilterCheckbox name="towerType" label="Тип вышки" values={values} prevValue={prevValue} onHandleChange={handleChange} />
    ),
    workingHeight: (min, max, handleChange) => (
        <FilterRangeSlider name="workingHeight" label="Рабочая высота, м" min={min} max={max} step={0.1} onHandleChange={handleChange} />
    ),
    verticalReach: (min, max, handleChange) => (
        <FilterRangeSlider
            name="verticalReach"
            label="Вертикальный вылет, м"
            min={min}
            max={max}
            step={0.1}
            onHandleChange={handleChange}
        />
    ),
    horizontalReach: (min, max, handleChange) => (
        <FilterRangeSlider name="horizontalReach" label="Горизонт. вылет, м" min={min} max={max} step={0.1} onHandleChange={handleChange} />
    ),
    enginesType: (values, prevValue, handleChange) => (
        <FilterCheckbox name="enginesType" label="Тип двигателя" values={values} prevValue={prevValue} onHandleChange={handleChange} />
    ),
    liftingHeight: (min, max, handleChange) => (
        <FilterRangeSlider name="liftingHeight" label="Высота подъема, м" min={min} max={max} step={0.1} onHandleChange={handleChange} />
    ),
    subcategory: (values, prevValue, handleChange, type) => {
        if (type === 'subcategoriesCheckbox') {
            return (
                <SubcategoriesCheckbox
                    name="subcategory"
                    label="Подкатегории"
                    values={values}
                    prevValue={prevValue}
                    onHandleChange={handleChange}
                />
            );
        } else {
            return (
                <SubcategoriesRadio
                    name="subcategory"
                    label="Подкатегории"
                    value={prevValue}
                    values={values}
                    onHandleChange={handleChange}
                />
            );
        }
    },
};
